import { useMemo } from 'react';
import type { FunctionComponent } from 'react';
import ResultDialog from '../../components/organisms/ResultDialog';
import { getIntroConcept } from './defaults';
import type { Concept } from '../../data/Concepts';

export interface Props {
	onNext: (concept: Concept) => void;
}

const ResultIntroScreen: FunctionComponent<Props> = (props: Props) => {
	const { onNext } = props;

	const enabledConcept = useMemo(() => getIntroConcept(), []);

	return <ResultDialog concept={enabledConcept} onNext={onNext} />;
};

export default ResultIntroScreen;
